import { Component } from '@angular/core';

@Component({
  selector: 'sign-section-wrapper',
  standalone: true,
  imports: [],
  template: `
    <ng-content/>
    
  `,
  styleUrl: './sign-section-wrapper.component.scss'
})
export class SignSectionWrapperComponent {

}
